<template>
  <v-card class="pa-3 elevation-0 mt-4">
    <v-card-title class="pt-1">
      <div
        :class="`subtitle-1 ${titleColor}--text font-weight-bold pl-0`"
        @click.stop="goToDocs"
      >
        Release Brief
      </div>

      <v-spacer />

      <v-tooltip left>
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div
            class="cursor-pointer"
          >
            <v-col
              class="text-right py-0"
              v-bind="tooltipAttrs"
              v-on="tooltipOn"
            >
              <v-icon
                @click="goToDocs"
              >
                notifications_none
              </v-icon>
            </v-col>
          </div>
        </template>

        <span>Release Notes</span>
      </v-tooltip>
    </v-card-title>

    <v-row>
      <v-col class="px-0">
        <v-divider />
      </v-col>
    </v-row>

    <v-card-text>
      <v-col>
        <v-row class="pt-3">
          <v-col>
            <release-label
              type="new"
              text="Alias Mode"
            />

            <v-row class="caption pt-1">
              <p>
                Alias Mode facilitates internal users’ testing, troubleshooting, and user experience
                analysis by enabling them to view the application as any external user.
              </p>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="pt-3">
          <v-col>
            <release-label
              type="new"
              text="Viewable Impressions"
            />

            <v-row class="caption pt-1">
              <p>
                Pacing has a new column: Viewable Impressions. This column shows the number of viewable impressions from GAM.
              </p>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="pt-3">
          <v-col>
            <release-label
              type="new"
              text="Dashboard Cards"
            />

            <v-row class="caption pt-1">
              <p>
                Quickly capture the results of your most common reports by saving them as cards on your dashboards and home page.
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapState } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')

export default {
  name: 'WelcomeCard',
  components: {
    ReleaseLabel: () => import('@/dashboard/components/ReleaseLabel'),
  },
  data() {
    return {
      dismissed: null,
    }
  },
  computed: {
    ...mapLayoutGetters(['titleColor']),
    ...mapGetters(['alert', 'isInternalUser']),
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    goToDocs() {
      this.$router.push('/docs/releases')
      this.dismissFeaturePrompt()
    },
    async dismissFeaturePrompt() {
      this.dismissed = true

      const { user } = this
      const { email, personEmail, settings = {} } = user
      const alert = { dismissed: true }
      const doc = { settings: { ...settings, alert } }
      const docId = email || personEmail
      const data = { doc, docId }

      return this.$store.dispatch('auth/updateUserSettings', data)
    },
  },
}
</script>
